var map = {
	"./github.svg": "./src/components/icon/svg/github.svg",
	"./linkedin.svg": "./src/components/icon/svg/linkedin.svg",
	"./twitter.svg": "./src/components/icon/svg/twitter.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svg ^\.\/.*\.svg$
// module id = 1
// module chunks = 88746230898986 102538987983895